export const version = "hash/5.0.11";
//# sourceMappingURL=_version.js.map